module.exports = __webpack_public_path__ + "img/admin-back-button.c64c9c87.svg";